module.exports = __webpack_public_path__ + "img/yjjy.8cc9f54a.png";